// features/workstations/qqq/today/index.js
// ═══════════════════════════════════════════════════════════
// TODAY sub-tab — active trading view
// ═══════════════════════════════════════════════════════════
//
// Per docs/QQQ_DASHBOARD_REBUILD_SPEC.md Section II.
//
// 2026-04-29 — Tim reduced the dashboard to the INTERPRETATION
// layer only. Chart-pattern reading (Yellow Candle anatomy, F15
// retest detection) lives on his TOS chart where he reads the
// actual bars. The dashboard's job is the meta-level trading
// frame — what's the macro read, what events are scheduled,
// what news is moving the tape, which vehicle to use, where do
// I capture observations.
//
// Card layout (top to bottom):
//   1. Morning Outlook         ✓ Shift's Jarvis 5-point read (NEW)
//   2. Macro Frame Zone        ✓ date + composite chip + briefing
//   3. Pre-Event Composite     ✓ 6-signal score (the WHY)
//   4. Vehicle Decision        ✓ 100% benchmark + IV crush + sizing
//   5. Economic Calendar       ✓ today's scheduled events
//   6. News Feed               ✓ live news + Whisperer
//   7. Open Observations       ✓ personal capture
//
// The Morning Outlook synthesizes everything below it into a
// 5-section narrative read. It's the FIRST thing Tim sees and
// the highest-value card on the dashboard.
//
// Removed (Tim handles on TOS):
//   - Yellow Candle Status     pattern detection at the bar level
//   - F15 Levels               levels + retest reading
// ═══════════════════════════════════════════════════════════

import MorningOutlookCard    from './morning-outlook-card.js';
import MacroFrameZone        from './macro-frame-zone.js';
import CompositeCard         from './composite-card.js';
import VehicleDecisionCard   from './vehicle-decision-card.js';
import EconomicCalendarCard  from './economic-calendar-card.js';
import NewsFeedCard          from './news-feed-card.js';
import OpenObservationsCard  from './open-observations-card.js';

export default function TodayTab({ workstation, userId, userRecord, resolvedAiName }) {
  return (
    <div className="qqq-today-tab">
      <MorningOutlookCard workstation={workstation} userId={userId} />
      <MacroFrameZone workstation={workstation} userId={userId} />

      <div className="qqq-today-tab__cards qqq-today-tab__cards--single">
        <CompositeCard />
        <VehicleDecisionCard />
        <EconomicCalendarCard />
        <NewsFeedCard userId={userId} />
        <OpenObservationsCard workstation={workstation} userId={userId} />
      </div>
    </div>
  );
}
